import { render, staticRenderFns } from "./ShRadio.vue?vue&type=template&id=f8bc5c7e&scoped=true&"
import script from "./ShRadio.vue?vue&type=script&lang=js&"
export * from "./ShRadio.vue?vue&type=script&lang=js&"
import style0 from "./ShRadio.vue?vue&type=style&index=0&id=f8bc5c7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8bc5c7e",
  null
  
)

export default component.exports